export default __webpack_public_path__ + "static/media/polaroid11.5f68ea22.jpg";